import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	components: {
		
	},
	data() {
		return {
			vacationId: '', //活动id
			detailModel: {}
		}
	},
	created() {
		this.activityId = this.$route.query.id ||''
		this.getActivityDetail()
	},
	methods: {
		//获取活动详情
		async getActivityDetail() {
			let param = {
				id: this.activityId
			}
			ajaxParam(param)
			const res = await post('admin/vacation/detail', qs.stringify(param))
			this.detailModel = res.data.entity
		}
	}
}
